export const smartDocStaticParamType_PhysicianNotes = 'physician-notes';
//# sourceMappingURL=types.js.map